import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth/auth.service';
import { Router } from '@angular/router';
import { LayoutService } from '../../core/layout/layout.service';
import { Title } from '@angular/platform-browser';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-sign-up',
  standalone: true,
  imports: [CommonModule, TranslocoModule, ReactiveFormsModule],
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignUpComponent implements OnInit {
  public signUpGroup: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/)]),
    passwordConfirm: new FormControl('', [Validators.required, this.passwordMatchValidator]),
    privacyPolicy: new FormControl(false, [Validators.requiredTrue]),
  });

  constructor(private authService: AuthService, private router: Router, private layoutService: LayoutService, private title: Title, private transloco: TranslocoService) {}

  // -----------------------------------------------------------------------------------------------------
  //  @ Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.title.setTitle(this.transloco.translate('Sign Up') + ' - zammy');
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  public onClickSubmit(): void {
    const { firstName, lastName, email, password } = this.signUpGroup.value;
    this.layoutService.loading = true;
    this.authService.createUser(firstName, lastName, email, password).subscribe((res: any) => {
      this.layoutService.loading = false;
      this.router.navigate(['/verification'], { queryParams: { redirectUrl: this.authService.redirectUrl, email } });
    });
  }

  public onClickCancel(): void {
    this.router.navigate(['/sign-in'], { queryParams: { redirectUrl: this.authService.redirectUrl } });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  private passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.parent) return null;
    const password = control.parent.get('password');
    const passwordConfirm = control.parent.get('passwordConfirm');
    return password && passwordConfirm && password.value === passwordConfirm.value ? null : { passwordMismatch: true };
  }
}
